import LayoutStyles from "../@types/api/styles";
import { ApiStylesBehavior_AllowedMenuType, ApiStylesBehavior_ArticleViewType } from "../@types/enums/styles";
import { getDefaultLayoutSettings } from "../styles/defaultLayoutSettings";
import { OrderType } from "../@types/enums/OrderType";
import { ArticleViewType } from "../@types/enums/ArticleViewType";

export const moveToSubCategory = (id: number) => {
    const dom: any = document.querySelector(`#subCategory_${id}`);
    if (dom) {
        const y = dom.offsetTop;
        window.scrollTo(0, y - 160);
    }
}

export const moveToTop = () => {
    window.scrollTo(0, 0);
}

export const applyLayoutStylse = (styles: LayoutStyles | undefined = undefined) => {
    let layoutSettings = getDefaultLayoutSettings();

    if (styles) {
        layoutSettings.fontMenuSubCategorySize = `${parseFloat(layoutSettings.fontMenuSubCategorySize) + (styles.article.fontSize || 0)}px`;
        layoutSettings.fontTileArticleTitleSize = `${parseFloat(layoutSettings.fontTileArticleTitleSize) + (styles.general.fontSize || 0)}px`;
        layoutSettings.fontHeaderMenuCategorySize = `${parseFloat(layoutSettings.fontHeaderMenuCategorySize) + (styles.header.fontSize || 0)}px`;
        layoutSettings.fontHeaderMenuSubCategorySize = `${parseFloat(layoutSettings.fontHeaderMenuSubCategorySize) + (styles.header.fontSize || 0)}px`;

        layoutSettings.buttonColor = styles.button.color || layoutSettings.buttonColor;
        layoutSettings.buttonAccentColor = styles.button.accentColor || layoutSettings.buttonAccentColor;

        layoutSettings.fontGeneralColor = styles.general.fontColor || layoutSettings.fontGeneralColor;
        layoutSettings.fontHeaderColor = styles.header.fontColor || layoutSettings.fontHeaderColor;
        layoutSettings.accentColor = styles.general.accentColor || layoutSettings.accentColor;
        layoutSettings.accentDarkColor = styles.general.accentSecondColor || layoutSettings.accentDarkColor;
        layoutSettings.backgroundGeneralColor = styles.general.backgroundColor || layoutSettings.backgroundGeneralColor;
        layoutSettings.backgroundTileColor = styles.article.backgroundColor || layoutSettings.backgroundTileColor;
        layoutSettings.fontNegativeColor = styles.general.fontNegativeColor || layoutSettings.fontNegativeColor;

        layoutSettings.fontFamily = styles.general.fontFamily || layoutSettings.fontFamily;

        if (styles.behavior?.allowedMenuType) {
            switch(styles.behavior.allowedMenuType) {
                case ApiStylesBehavior_AllowedMenuType.ALL:
                    localStorage.removeItem("allowedMenuTypes");
                    break;
                case ApiStylesBehavior_AllowedMenuType.EAT_IN:
                    localStorage.setItem("allowedMenuTypes", OrderType.EAT_IN);
                    break;
                case ApiStylesBehavior_AllowedMenuType.TAKE_AWAY:
                    localStorage.setItem("allowedMenuTypes", OrderType.TAKEAWAY);
                    break;
                default:
                    localStorage.removeItem("allowedMenuTypes");
            }
        }

        if (styles.behavior?.articleViewType) {
            switch(styles.behavior.articleViewType) {
                case ApiStylesBehavior_ArticleViewType.TOGETHER:
                    localStorage.setItem("articleViewType", ArticleViewType.ONE_PAGE);
                    break;
                case ApiStylesBehavior_ArticleViewType.GROUP_BY_TYPE:
                    localStorage.setItem("articleViewType", ArticleViewType.GROUP_PAGE);
                    break;
                case ApiStylesBehavior_ArticleViewType.SEPARATELY:
                    localStorage.setItem("articleViewType", ArticleViewType.INDIVIDUAL_PAGE);
                    break;
                default:
                    localStorage.setItem("articleViewType", ArticleViewType.ONE_PAGE);
            }
        }

    }

    const root = document.documentElement;
    Object.entries(layoutSettings).forEach(([key, value]) => {
      root.style.setProperty(`--${key}`, value);
    });
  };